// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__DAIV-","label":"Completed_label__1dA1R"};